export default __webpack_public_path__ + "e691a51e44633d05f2754babda5767e0.svg";